exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-responsive[data-v-92c99840]{overflow-x:auto}.bg-gray[data-v-92c99840]{background-color:#f5f5f5!important}.label[data-v-92c99840]{display:inline-block;padding:2px 6px;font-size:11px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:4px}.label-success[data-v-92c99840]{background-color:#5cb85c}.label-danger[data-v-92c99840]{background-color:#d9534f}.label-default[data-v-92c99840]{background-color:#999}.small-box[data-v-92c99840]{margin-bottom:15px}.text-right[data-v-92c99840]{text-align:right}.text-center[data-v-92c99840]{text-align:center}.text-success[data-v-92c99840]{color:#3c763d!important}.text-danger[data-v-92c99840]{color:#a94442!important}.text-muted[data-v-92c99840]{color:#999!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-92c99840","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/growthDashboard/ClientWiseGrowthComponent.vue
// module id = 1751
// module chunks = 0